import { Component, ViewChild } from '@angular/core';
import { MatDialogRef, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { FieldMetadata, ViewMetadata, FieldWidthEnum } from '@data/cer-data-types';

import { UiCommand, UiCommandEvent, UiKeyboardShortcut } from '@ui/cer-ui-types';
import { CerUiIcons } from '@ui/cer-ui-icons';
import { CerPromptService, PromptInput } from '@ui/cer-ui-prompt.service';

import { CerFormPanesSettings, uiCmdPaneBottomClose, uiCmdPaneBottomToggle } from '@form/cer-form-panes/cer-form-panes.service';
import { CerFormComponent } from '@form/cer-form.component';

import { CerSessionService } from 'src/cer/cer-session/cer-session.service';

import { CerGridComponent } from 'src/cer/cer-grid/cer-grid.component';
import { GridComponent } from '@syncfusion/ej2-angular-grids';

import { VoucherDetailComponent } from 'src/app/voucher/voucher-detail/voucher-detail.component';
import { VoucherService } from 'src/app/voucher/voucher.service';
import { CerAppRouteService } from 'src/cer-app/cer-app-route/cer-app-route.service';
import { VoucherDataService } from 'src/app/voucher/voucher-data.service';
import { CerAppStateService } from 'src/cer-app/cer-app-state/cer-app-state.service';

import { CerAppChatService } from 'src/cer-app/cer-app-chat/cer-app-chat.service';
import { CustInvoiceService } from 'src/app/sales/cust-invoice.service';
import { CustInvoiceView } from 'src/app/sales/cust-invoice.view';
import { BankAccountSourceSyncCommand, BankTransactionSourceBatchClient, BankSettlementStatusEnum, BankAccountTransactionDto, BankTransactionStatusSetCommand, BankAccountTransactionVoucherCreateCommand, VoucherMessageViewDetailsClient, VoucherMessageViewDetailsVm, BankAccountSettlementClient, BankTransactionVoucherCombineSelectedCommand, BankTransactionSuggestSettlementCommand, BankAccountTransactionClient, VoucherMessageStatusEnum, VoucherMessageViewClient } from 'src/app/api';

@Component({
  selector: 'bank-account-settlement',
  templateUrl: './bank-account-settlement.component.html',
  styleUrls: [],
  providers: [VoucherService]
})
export class BankAccountSettlementComponent {

  form: CerFormComponent;
  @ViewChild('form', { static: false }) set formContent(content: CerFormComponent) {
    if (content && !this.form) {
      this.form = content;
      this.form.commmand.subscribe(e => this.onCommand(e));
    }
  }

  protected panes: CerFormPanesSettings = {
    top: {
      visible: 'show',
      visibleWhenClose: 'collapse',
      size: '25%'
    },
    main: {
      visible: 'show',
      visibleWhenClose: 'collapse',
      size: '55%',
      sizeSecondary: '50%'
    },
    right: {
      visible: 'show',
      visibleWhenClose: 'collapse',
      size: '50%'
    },
    bottomLeft: {
      visible: 'show',
      visibleWhenClose: 'collapse',
      size: '40%'
    },
    bottom: {
      visible: 'collapse',
      visibleWhenClose: 'collapse',
      size: '25%',
      sizeSecondary: '30%'
    },
    bottomRight: {
      visible: 'hide', // Enable if balance enabled
      visibleWhenClose: 'collapse',
      size: '30%'
    },
    orientationPrimary: 'vertical'
  }

  selectedGrid: CerGridComponent;
  @ViewChild('selectedGrid', { static: false }) set selectedGridContent(content: CerGridComponent) {
    if (content) {
      this.selectedGrid = content;
      //this.selectedGrid.grid.allowRowDragAndDrop = true;
      //this.selectedGrid.grid.rowDropSettings = { targetID: 'detailGrid' };
      this.selectedGrid.commmand.subscribe(e => this.onCommand(e));
    }
  }

  grid: CerGridComponent;
  @ViewChild('grid', { static: false }) set gridContent(content: CerGridComponent) {
    if (content) {
      this.grid = content;
      //this.grid.grid.allowRowDragAndDrop = true;
      //this.grid.grid.rowDropSettings = { targetID: 'detailGrid' };
      this.grid.commmand.subscribe(e => this.onCommand(e));
    }
  }
  detailGrid: CerGridComponent;
  @ViewChild('detailGrid', { static: false }) set gridContentDetail(content: CerGridComponent) {
    if (content) {
      this.detailGrid = content;
      //this.detailGrid.grid.allowRowDragAndDrop = true;
      this.detailGrid.commmand.subscribe(e => this.onCommand(e));
    }
  }

  private invoiceGrid: CerGridComponent;
  @ViewChild('invoiceGrid', { static: false }) set invoiceGridContent(content: CerGridComponent) {
    if (content) {
      this.invoiceGrid = content;
      //this.balanceGrid.commmand.subscribe(e => this.onCommand(e));
    }
  }

  private invoiceLineGrid: CerGridComponent;
  @ViewChild('invoiceLineGrid', { static: false }) set invoiceLineGridContent(content: CerGridComponent) {
    if (content) {
      this.invoiceLineGrid = content;
      //this.balanceGrid.commmand.subscribe(e => this.onCommand(e));
    }
  }

  /*
  private balanceGrid: CerGridComponent;
  @ViewChild('balanceGrid', { static: false }) set balanceGridContent(content: CerGridComponent) {
    if (content && !this.balanceGrid) {
      this.balanceGrid = content;
      //this.balanceGrid.commmand.subscribe(e => this.onCommand(e));
    }
  }
  */


  private uiCmdVoucherCombine: UiCommand = { id: 'VoucherCombine', text: 'Kombiner', tooltipText: 'Kombiner bilag fra bankpostering (ALT+C)', iconCss: CerUiIcons.combine, target: '.e-content' };
  private uiCmdVoucherOpenForm: UiCommand = { id: 'VoucherOpenForm', text: 'Rediger bilag', tooltipText: 'Rediger bilag og kontering (ALT+B)', iconCss: CerUiIcons.editDetails, target: '.e-content', needSelection: true };
  private uiCmdVoucherOpenFormMain: UiCommand = { id: 'VoucherOpenForm', text: 'Rediger bilag', tooltipText: 'Rediger bilag og kontering (ALT+B)', iconCss: CerUiIcons.editDetails, target: '.e-content', needSelection: true };
  private uiCmdVoucherCreateFromBankSelected: UiCommand = { id: 'VoucherCreateFromBankSelected', text: 'Nyt bilag fra bank', tooltipText: 'Opret nyt bilag ud fra bankpostering  (ALT+CTRL+N)', iconCss: CerUiIcons.createFrom, target: '.e-content', needSelection: true };
  private uiCmdVoucherCreateFromBankMain: UiCommand = { id: 'VoucherCreateFromBankMain', text: 'Nyt bilag fra bank', tooltipText: 'Opret nyt bilag ud fra bankpostering  (ALT+CTRL+N)', iconCss: CerUiIcons.createFrom, target: '.e-content', needSelection: true };
  private uiCmdVoucherCreate: UiCommand = { id: 'VoucherCreate', text: 'Nyt bilag', tooltipText: 'Opret nyt tom bilag (ALT+N)', iconCss: CerUiIcons.create, target: '.e-content' };
  private uiCmdPaneInvoiceShow: UiCommand = Object.assign(new Object(), uiCmdPaneBottomToggle, { text: 'Faktura', tooltipText: 'Vis faktura (ALT+I)', iconCss: CerUiIcons.checkMark, target: '.e-content' });
  private uiCmdPaneInvoiceClose = Object.assign(new Object(), uiCmdPaneBottomClose, { text: '', tooltipText: 'Luk faktura' });
  //private uiCmdBalanceShow: UiCommand = Object.assign(new Object(), uiCmdPaneBottomRightToggle, { text: 'Saldo', tooltipText: 'Vis afstemning banksaldo (ALT+T)', iconCss:  CerUiIcons.checkMark, target: '.e-content' });
  //private uiCmdBalanceClose = Object.assign(new Object(), uiCmdPaneBottomRightClose, { text: 'Banksaldo afstemning', tooltipText: 'Luk banksaldo afstemning' });

  private uiCmdSetStatusMarkedSuggest: UiCommand = { id: 'uiCmdSetStatusMarkedSuggest', text: 'Forslag', tooltipText: 'Søg forslag til markerede poster (ALT+S)', iconCss: CerUiIcons.searchSuggest, target: '.e-content' };
  private uiCmdSetStatusMarked: UiCommand = { id: 'SetStatusMarked', text: 'Vælg', tooltipText: 'Vælg de markerede poster (ALT+V)', iconCss: CerUiIcons.changes, target: '.e-content', needSelection: true };
  private uiCmdSetStatusOpen: UiCommand = { id: 'SetStatusOpen', text: 'Åbn', tooltipText: 'Sæt status åbn for de markerede poster (ALT+B)', iconCss: CerUiIcons.changesCancel, target: '.e-content', needSelection: true };
  private uiCmdSetStatusRequest: UiCommand = { id: 'SetStatusRequested', text: 'Anmod', tooltipText: 'Anmod om bilag for markeret (ALT+R)', iconCss: CerUiIcons.changesReopen, target: '.e-content', needSelection: true };
  private uiCmdSetStatusPostponed: UiCommand = { id: 'SetStatusPostponed', text: 'Udsæt', tooltipText: 'Udsæt markerede poster (ALT+U)', iconCss: CerUiIcons.changesReject, target: '.e-content', needSelection: true };
  private uiCmdSetStatusSettled: UiCommand = { id: 'SetStatusSettled', text: 'Afstem', tooltipText: "Sæt status 'Afstemt' for alle poster (ALT+A)", iconCss: CerUiIcons.changesAccept, target: '.e-content', needSelection: true };
  private uiCmdSetStatusCreated: UiCommand = { id: 'SetStatusCreated', text: "Sæt status 'Oprettet'", tooltipText: "Sæt status 'Oprettet for bilag (ALT+O)", iconCss: CerUiIcons.changesReject, target: '.e-content', needSelection: true };
  private uiCmdSetStatusPendingApproval: UiCommand = { id: 'SetStatusPendingApproval', text: "Sæt status 'Til godkendelse'", tooltipText: 'Sæt status til godkendelse for (ALT+X)', iconCss: CerUiIcons.commentReopen, target: '.e-content', needSelection: true };
  private uiCmdSetStatusApproved: UiCommand = { id: 'SetStatusApproved', text: "Sæt status 'Godkendt'", tooltipText: "Sæt status 'Godkendt' for bilag (ALT+G)", iconCss: CerUiIcons.changesAccept, target: '.e-content', needSelection: true };
  private uiCmdSetStatusRejected: UiCommand = { id: 'SetStatusRejected', text: "Sæt status 'Annulleret'", iconCss: CerUiIcons.cancel, target: ".e-content", needSelection: true };

  private uiCmdSeparator: UiCommand = { id: 'Separator', text: null, separator: 'content' };

  private uiCmdVoucherCombineShortcut: UiKeyboardShortcut = { cmd: this.uiCmdVoucherCombine, code: 'KeyC', shift: false, ctrl: false, alt: true };

  private uiCmdVoucherOpenFormShortcut: UiKeyboardShortcut = { cmd: this.uiCmdVoucherOpenForm, code: 'KeyB', shift: false, ctrl: false, alt: true };
  private uiCmdVoucherCreateFromBankMainShortcut: UiKeyboardShortcut = { cmd: this.uiCmdVoucherCreateFromBankMain, code: 'KeyN', shift: false, ctrl: true, alt: true };
  private uiCmdVoucherCreateShortcut: UiKeyboardShortcut = { cmd: this.uiCmdVoucherCreate, code: 'KeyN', shift: false, ctrl: false, alt: true };

  private uiCmdSetStatusOpenShortcut: UiKeyboardShortcut = { cmd: this.uiCmdSetStatusOpen, code: 'KeyO', shift: false, ctrl: false, alt: true };
  private uiCmdSetStatusMarkedSuggestShortcut: UiKeyboardShortcut = { cmd: this.uiCmdSetStatusMarkedSuggest, code: 'KeyS', shift: false, ctrl: false, alt: true };
  private uiCmdSetStatusMarkedShortcut: UiKeyboardShortcut = { cmd: this.uiCmdSetStatusMarked, code: 'KeyV', shift: false, ctrl: false, alt: true };
  private uiCmdSetStatusPostponedShortcut: UiKeyboardShortcut = { cmd: this.uiCmdSetStatusPostponed, code: 'KeyU', shift: false, ctrl: false, alt: true };
  private uiCmdSetStatusSettledShortcut: UiKeyboardShortcut = { cmd: this.uiCmdSetStatusSettled, code: 'KeyA', shift: false, ctrl: false, alt: true };

  public viewMetadata: ViewMetadata;
  public fieldMetadata: FieldMetadata[] = [];
  public toolbarCommands: UiCommand[];
  public contextMenuCommands: UiCommand[];
  public keyboardShortcuts: UiKeyboardShortcut[];

  public detailViewMetadata: ViewMetadata;
  public detailFieldMetadata: FieldMetadata[] = [];
  public detailToolbarCommands: UiCommand[];
  public detailContextMenuCommands: UiCommand[];
  public detailKeyboardShortcuts: UiKeyboardShortcut[];

  public selectedViewMetadata: ViewMetadata;
  public selectedFieldMetadata: FieldMetadata[] = [];
  public selectedToolbarCommands: UiCommand[];
  public selectedContextMenuCommands: UiCommand[];
  public selectedKeyboardShortcuts: UiKeyboardShortcut[];

  public invoiceViewMetadata: ViewMetadata;
  public invoiceFieldMetadata: FieldMetadata[] = [];
  public invoiceToolbarCommands: UiCommand[];
  public invoiceContextMenuCommands: UiCommand[];
  public invoiceKeyboardShortcuts: UiKeyboardShortcut[];

  public invoiceLineViewMetadata: ViewMetadata;
  public invoiceLineFieldMetadata: FieldMetadata[] = [];
  public invoiceLineToolbarCommands: UiCommand[];
  public invoiceLineContextMenuCommands: UiCommand[];
  public invoiceLineKeyboardShortcuts: UiKeyboardShortcut[];

  public balanceViewMetadata: ViewMetadata;
  public balanceFieldMetadata: FieldMetadata[] = [];
  public balanceToolbarCommands: UiCommand[];
  public balanceContextMenuCommands: UiCommand[];
  public balanceKeyboardShortcuts: UiKeyboardShortcut[];


  constructor(private custInvoiceService: CustInvoiceService,
    private routeService: CerAppRouteService,
    private session: CerSessionService,
    private stateService: CerAppStateService,
    private transactionClient: BankAccountTransactionClient,
    private settlementClient: BankAccountSettlementClient,
    private voucherMessageViewClient: VoucherMessageViewClient,
    private batchClient: BankTransactionSourceBatchClient,
    private detailsClient: VoucherMessageViewDetailsClient,
    private voucherService: VoucherService,
    private chatService: CerAppChatService,
    private ui: CerPromptService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar) {

    this.selectedGridInit();
    this.gridInit();
    this.detailsGridInit();
    this.invoiceGridInit();
    //this.balanceGridInit();
  }

  // Selected
  private selectedGridInit() {
    this.selectedViewMetadata = {
      name: 'bank-transaktion-valgte', dataApiName: 'BankAccountTransaction', text: 'Valgte',
      primaryKey: 'id', allowEdit: false, allowCreate: false, allowDelete: false, baseFields: ['id', 'history']
    };

    var userId: number = this.session.user.id();
    this.selectedFieldMetadata =
      [
        { name: 'sourceBatch', text: 'Batch', visible: false, orderBy: 'Ascending', orderByPriority: 1 },
        { name: 'bankAccount', text: 'Bankkonto', foreignKeyTableName: 'BankAccount', widthType: FieldWidthEnum.XXXS, visible: false },
        { name: 'source', text: 'Kilde', foreignKeyTableName: 'BankAccountTransactionSource', widthType: FieldWidthEnum.XXXS, visible: true },
        { name: 'transDate', text: 'Dato', format: 'DateShort', widthType: FieldWidthEnum.XXXS, orderBy: 'Descending', orderByPriority: 2 },
        { name: 'txt', text: 'Tekst', widthType: FieldWidthEnum.XXXL },
        { name: 'authReference', text: "Reference", widthType: FieldWidthEnum.XXS },
        { name: 'bankCreditCard', text: "Kreditkort", widthType: FieldWidthEnum.XS, foreignKeyTableName: 'BankCreditCard', visible: false },
        { name: 'user', text: 'Medarbejder', widthType: FieldWidthEnum.XXXS, foreignKeyTableName: 'User', foreignKeyValue: 'shortName' },
        { name: 'amount', text: 'Beløb', format: 'Amount', widthType: FieldWidthEnum.XS, footerType: 'Sum'},
        { fieldType: 'currencyId' },
        { name: 'status', text: 'Status', foreignKeyTableName: 'BankAccountTransactionStatus', widthType: FieldWidthEnum.XXXS, filterOperator: 'equal', filterValue: BankSettlementStatusEnum.Selected, filterOnClient: true },
        { name: 'modifiedBy', text: 'Bruger', foreignKeyTableName: 'User', foreignKeyValue: 'shortName', widthType: FieldWidthEnum.XXXS, filterOperator: 'equal', filterValue: userId, filterOnClient: true }
      ];

    this.selectedToolbarCommands = [this.uiCmdSetStatusMarkedSuggest, this.uiCmdVoucherCreate, this.uiCmdVoucherCreateFromBankSelected, this.uiCmdSeparator, this.uiCmdVoucherCombine, this.uiCmdVoucherOpenForm, this.uiCmdSeparator, this.uiCmdSetStatusSettled, this.uiCmdSeparator, this.uiCmdSetStatusOpen, this.uiCmdSetStatusPostponed];
    this.selectedKeyboardShortcuts = [this.uiCmdSetStatusSettledShortcut, this.uiCmdSetStatusMarkedSuggestShortcut, this.uiCmdVoucherCombineShortcut, this.uiCmdVoucherCreateShortcut, this.uiCmdVoucherCreateFromBankMainShortcut, this.uiCmdVoucherOpenFormShortcut, this.uiCmdSetStatusOpenShortcut, this.uiCmdSetStatusPostponedShortcut];
    this.selectedContextMenuCommands = [this.uiCmdVoucherOpenForm, this.uiCmdSeparator, this.uiCmdSetStatusOpen, this.uiCmdSetStatusPostponed];
  }

  // Main (vouchers)
  private gridInit() {
    this.viewMetadata = {
      name: 'bank-bilag', dataApiName: 'BankAccountTransaction', text: 'Bilag',
      dataApiParams: ['$sourceGroupIdFilter=1'],
      primaryKey: 'id', allowEdit: false, allowCreate: false, allowDelete: false, baseFields: ['history']
    };

    this.fieldMetadata =
      [{ name: 'id', text: 'Id', tooltipText: 'Unik nøgle for posten', widthType: FieldWidthEnum.XXXS, visible: false },
      { name: 'sourceBatch', text: 'Batch', widthType: FieldWidthEnum.XXXS, visible: false },
      { name: 'bankAccount', text: 'Bankkonto', foreignKeyTableName: 'BankAccount', widthType: FieldWidthEnum.XXXS, visible: false },
      { name: 'source', text: 'Kilde', foreignKeyTableName: 'BankAccountTransactionSource', widthType: FieldWidthEnum.XXXS, visible: false, filterOperator: 'equal', filterValue: '1', filterOnClient: true },
      { name: 'sourceId', text: 'Besked id', widthType: FieldWidthEnum.XXXS, visible: false },
      { name: 'transDate', text: 'Dato', format: 'DateShort', widthType: FieldWidthEnum.XXXS, orderBy: 'Descending' },
      { name: 'txt', text: 'Tekst', widthType: FieldWidthEnum.XXXL },
      { name: 'authReference', text: "Reference", widthType: FieldWidthEnum.XXS },
      { name: 'user', text: 'Medarbejder', widthType: FieldWidthEnum.XXXS, foreignKeyTableName: 'User', foreignKeyValue: 'shortName' },
      { name: 'amount', text: 'Beløb', format: 'Amount', widthType: FieldWidthEnum.XS, footerType: 'Custom', footerFunction: this.selectedAmountSumFn },
      { fieldType: 'currencyId' },
      { name: 'status', text: 'Status', foreignKeyTableName: 'BankAccountTransactionStatus', widthType: FieldWidthEnum.XS, filterOperator: 'in', filterValue: [BankSettlementStatusEnum.Open, BankSettlementStatusEnum.Postponed, BankSettlementStatusEnum.Requested, BankSettlementStatusEnum.Created, BankSettlementStatusEnum.PendingApproval, BankSettlementStatusEnum.Approved]/*, filterOnClient: true*/ }
      ];

    this.toolbarCommands = [this.uiCmdSetStatusMarked, this.uiCmdSeparator, this.uiCmdVoucherOpenFormMain, this.uiCmdPaneInvoiceShow];
    this.keyboardShortcuts = [this.uiCmdVoucherOpenFormShortcut, , this.uiCmdSetStatusMarkedSuggestShortcut, this.uiCmdVoucherCreateShortcut, this.uiCmdSetStatusOpenShortcut, this.uiCmdSetStatusPostponedShortcut, this.uiCmdSetStatusMarkedShortcut];
    this.contextMenuCommands = [this.uiCmdSetStatusMarked, this.uiCmdSeparator, this.uiCmdVoucherOpenFormMain, this.uiCmdSeparator, this.uiCmdSetStatusOpen, this.uiCmdSetStatusPostponed, this.uiCmdSeparator, this.uiCmdSetStatusCreated, this.uiCmdSetStatusPendingApproval, this.uiCmdSetStatusApproved, this.uiCmdSetStatusRejected];
  }

  // Details (bank transactions)
  private detailsGridInit() {
    this.detailViewMetadata = {
      name: 'bank-transaktion', dataApiName: 'BankAccountTransaction', text: 'Bank',
      dataApiParams: ['$sourceGroupIdFilter=2', '$activeAccountFilter=1'],
      primaryKey: 'id', allowEdit: true, allowCreate: false, allowDelete: false, baseFields: ['history']
    };

    this.detailFieldMetadata =
      [{ name: 'id', text: 'Id', tooltipText: 'Unik nøgle for posten', widthType: FieldWidthEnum.XXXS, visible: false, orderBy: 'Descending' },
      { name: 'sourceBatch', text: 'Batch', widthType: FieldWidthEnum.XXXS, visible: false, allowEdit: false },
      { name: 'bankAccount', text: 'Bankkonto', foreignKeyTableName: 'BankAccount', widthType: FieldWidthEnum.XXXS, visible: false, allowEdit: false },
      { name: 'source', text: 'Kilde', foreignKeyTableName: 'BankAccountTransactionSource', widthType: FieldWidthEnum.XXXS, visible: false, allowEdit: false },
      { name: 'transDate', text: 'Dato', format: 'DateShort', widthType: FieldWidthEnum.XXXS, allowEdit: false },
      { name: 'txt', text: 'Tekst', widthType: FieldWidthEnum.XXXL },
      { name: 'authReference', text: "Nota Indløser", widthType: FieldWidthEnum.XXS },
      { name: 'bankCreditCard', text: "Kreditkort", widthType: FieldWidthEnum.XS, foreignKeyTableName: 'BankCreditCard', visible: false, allowEdit: false },
      { name: 'user', text: 'Medarbejder', widthType: FieldWidthEnum.XXXS, foreignKeyTableName: 'User', foreignKeyValue: 'shortName' },
      { name: 'amount', text: 'Beløb', format: 'Amount', widthType: FieldWidthEnum.XS, footerType: 'Custom', footerFunction: this.selectedAmountSumFn, allowEdit: false },
      { fieldType: 'currencyId', visible: false, allowEdit: false },
      { name: 'status', text: 'Status', foreignKeyTableName: 'BankAccountTransactionStatus', widthType: FieldWidthEnum.XXXS, filterOperator: 'in', filterValue: [BankSettlementStatusEnum.Open, BankSettlementStatusEnum.Postponed, BankSettlementStatusEnum.Requested], /*filterOnClient: true*/ /*, allowEdit: false*/ }
      ];

    this.detailToolbarCommands = [this.uiCmdSetStatusMarked, this.uiCmdSeparator, this.uiCmdSetStatusRequest, this.uiCmdVoucherCreateFromBankMain /*, this.uiCmdBalanceShow */];
    this.detailKeyboardShortcuts = [this.uiCmdSetStatusMarkedShortcut, this.uiCmdSetStatusMarkedSuggestShortcut, this.uiCmdVoucherCreateFromBankMainShortcut, this.uiCmdSetStatusOpenShortcut, this.uiCmdSetStatusPostponedShortcut, this.uiCmdSetStatusMarkedShortcut];
    this.detailContextMenuCommands = [this.uiCmdSetStatusMarked, this.uiCmdSeparator, this.uiCmdVoucherCreateFromBankMain, this.uiCmdSeparator, this.uiCmdSetStatusOpen, this.uiCmdSetStatusPostponed, this.uiCmdSetStatusRequest];
  }

  private invoiceGridInit() {
    this.invoiceViewMetadata = Object.assign({ parentPrimaryKey: 'sourceId', parentForeignKey: 'voucherMessage' }, CustInvoiceView.tableView([], true));
    this.invoiceFieldMetadata = CustInvoiceView.tableFields(true, true);
    this.invoiceToolbarCommands = Object.assign([], [this.uiCmdPaneInvoiceClose], CustInvoiceView.tableToolbar(true, false));
    this.invoiceContextMenuCommands = [];
    this.invoiceKeyboardShortcuts = [];

    this.invoiceLineViewMetadata = CustInvoiceView.lineView(true);
    this.invoiceLineFieldMetadata = CustInvoiceView.lineFields(true);
    this.invoiceLineToolbarCommands = CustInvoiceView.lineToolbar(true);
    this.invoiceLineContextMenuCommands = [];
    this.invoiceLineKeyboardShortcuts = [];
  }

  /*
  private balanceGridInit() {
    this.balanceViewMetadata = {
      name: 'bank-konto-saldo', dataApiUrl: '/api/BankAccountBalance', text: 'Afstemning',
      primaryKey: 'id', allowEdit: false, allowCreate: false, allowDelete: false, titleFields: ['transDate'],
      allowFiltering: false, allowSorting: false
    };

    this.balanceFieldMetadata =
      [
        { name: 'bankAccount', text: 'Bankkonto', foreignKeyTableName: 'BankAccount', widthType: FieldWidthEnum.XXXS },
        { name: 'transDate', text: 'Dato', format: 'DateShort', widthType: FieldWidthEnum.XXXS, orderBy: 'Descending', orderByPriority: 2 },
        { name: 'transCount', text: 'Antal', format: 'Integer', widthType: FieldWidthEnum.XXXS },
        { name: 'amount', text: 'Bank', format: 'Amount', widthType: FieldWidthEnum.S, footerType: 'Sum' },
        { name: 'balance', text: 'Saldo bank', format: 'Amount', widthType: FieldWidthEnum.S },
        { name: 'amountPosted', text: 'Bogført', format: 'Amount', widthType: FieldWidthEnum.S, footerType: 'Sum' },
        { name: 'balancePosted', text: 'Saldo bogført', format: 'Amount', widthType: FieldWidthEnum.S },
        { name: 'difference', text: 'Forskel', format: 'Amount', widthType: FieldWidthEnum.S, footerType: 'Sum' },
        { name: 'balanceDifference', text: 'Saldo forskel', format: 'Amount', widthType: FieldWidthEnum.S },
        { name: 'amountJournal', text: 'Kladde', format: 'Amount', widthType: FieldWidthEnum.XXS, footerType: 'Sum' },
        { name: 'amountAppJournal', text: 'Afsluttet', format: 'Amount', widthType: FieldWidthEnum.XXS, footerType: 'Sum' },
        { fieldType: 'currencyId', visible: false },
        { name: 'minStatus', text: 'Fra status', foreignKeyTableName: 'BankAccountTransactionStatus', widthType: FieldWidthEnum.XXXS },
        { name: 'maxStatus', text: 'Til status', foreignKeyTableName: 'BankAccountTransactionStatus', widthType: FieldWidthEnum.XXXS }
      ];

    this.balanceToolbarCommands = [this.uiCmdBalanceClose];
    this.balanceKeyboardShortcuts = [];
    this.balanceContextMenuCommands = [];
  }
  */

  public selectedAmountSumFn(data: Object): number {
    var grid = <GridComponent><any>this;
    var sum: number = 0;
    grid.getSelectedRecords().forEach(r => {
      sum += (<BankAccountTransactionDto>r).amount;
    });
    return sum;
  }

  private enableToolbarItems(g: CerGridComponent) {
    if (g?.grid?.toolbarModule && this.selectedGrid?.setupService) {
      var rows: any[] = this.selectedGrid.grid.getCurrentViewRecords();
      var count = rows?.length ?? 0;
      var voucherCount = rows?.filter(t => t.sourceId != null)?.length ?? 0;
      var bankCount = count - voucherCount;

      g.grid.toolbarModule.enableItems([this.uiCmdSetStatusMarkedSuggest.id], count <= 1);
      g.grid.toolbarModule.enableItems([this.uiCmdVoucherCreate.id], voucherCount == 0);
      g.grid.toolbarModule.enableItems([this.uiCmdVoucherCreateFromBankSelected.id], (voucherCount == 0 && bankCount > 0));
      g.grid.toolbarModule.enableItems([this.uiCmdVoucherCombine.id], (voucherCount > 0 && bankCount > 0));
      g.grid.toolbarModule.enableItems([this.uiCmdVoucherOpenForm.id], true); //voucherCount > 0);

      var status = count > 0 ? rows[0].status : null;
      g.grid.toolbarModule.enableItems([this.uiCmdSetStatusOpen.id], this.voucherService.BankStatusCanChange(status, BankSettlementStatusEnum.Open));
      g.grid.toolbarModule.enableItems([this.uiCmdSetStatusPostponed.id], this.voucherService.BankStatusCanChange(status, BankSettlementStatusEnum.Open));
      g.grid.toolbarModule.enableItems([this.uiCmdSetStatusSettled.id], this.voucherService.BankStatusCanChange(status, BankSettlementStatusEnum.Settled));
      if (g == this.grid) {
        g.grid.toolbarModule.enableItems([this.uiCmdSetStatusCreated.id], this.voucherService.BankStatusCanChange(status, BankSettlementStatusEnum.Created));
        g.grid.toolbarModule.enableItems([this.uiCmdSetStatusPendingApproval.id], this.voucherService.BankStatusCanChange(status, BankSettlementStatusEnum.PendingApproval));
        g.grid.toolbarModule.enableItems([this.uiCmdSetStatusApproved.id], this.voucherService.BankStatusCanChange(status, BankSettlementStatusEnum.Approved));
      }
    }
  }

  public onCommand(event: UiCommandEvent) {
    if ((event.actionType == 'dataBound' || event.actionType == 'rowSelect' || event.actionType == 'rowDeselect' || event.actionType == 'refresh') && (event.source == 'actionComplete')) {
      var g: CerGridComponent = <CerGridComponent>event.appComponent;
      if (g) {
        g.grid.aggregateModule.refresh(event.args.data);
        this.enableToolbarItems(g);
      }
    }

    if (event.actionType == 'rowDoubleClick') {
      var appGrid = this.getEventAppGrid(event);
      if (appGrid != null) {
        if ([this.selectedGrid.id, this.grid.id].includes(appGrid.id)) {
          event.commandId = this.uiCmdVoucherOpenForm.id;
        }
      }
    }
    switch (event.commandId) {
      case this.uiCmdVoucherCombine.id:
        this.voucherCombine(event);
        break;
      case this.uiCmdSetStatusMarkedSuggest.id:
        this.setStatusMarkedSuggest(event);
        break;
      case this.uiCmdVoucherOpenForm.id:
        this.voucherOpenForm(event);
        break;
      case this.uiCmdVoucherCreate.id:
        this.voucherCreate(event);
        break;
      case this.uiCmdVoucherCreateFromBankSelected.id:
      case this.uiCmdVoucherCreateFromBankMain.id:
        this.voucherCreateFromBank(event);
        break;
      case this.uiCmdSetStatusOpen.id:
        this.setStatusFromEvent(event, BankSettlementStatusEnum.Open);
        break;
      case this.uiCmdSetStatusPostponed.id:
        this.setStatusFromEvent(event, BankSettlementStatusEnum.Postponed);
        break;
      case this.uiCmdSetStatusRequest.id:
        this.setStatusFromEvent(event, BankSettlementStatusEnum.Requested);
        break;
      case this.uiCmdSetStatusMarked.id:
        this.setStatusFromEvent(event, BankSettlementStatusEnum.Selected);
        break;
      case this.uiCmdSetStatusSettled.id:
        this.setStatusFromEvent(event, BankSettlementStatusEnum.Settled);
        break;
      case this.uiCmdSetStatusCreated.id:
        this.setStatusFromEvent(event, BankSettlementStatusEnum.Created);
        break;
      case this.uiCmdSetStatusPendingApproval.id:
        this.setStatusFromEvent(event, BankSettlementStatusEnum.PendingApproval);
        break;
      case this.uiCmdSetStatusApproved.id:
        this.setStatusFromEvent(event, BankSettlementStatusEnum.Approved);
        break;
      case this.uiCmdSetStatusRejected.id:
        var msgId: number = this.getEventMsgId(event);
        this.apiVoucherMessageStatusSet(msgId, VoucherMessageStatusEnum.Rejected);
        break;
    }
  }

  private setStatusFromEvent(event: UiCommandEvent, status: BankSettlementStatusEnum) {
    if (event.appComponent !== null && event.appComponent instanceof CerGridComponent) {
      var appGrid: CerGridComponent = event.appComponent as CerGridComponent;
      this.setStatus(appGrid, status);
    }
  }

  private setStatus(appGrid: CerGridComponent, status: BankSettlementStatusEnum) {

    var transactionFirst: BankAccountTransactionDto = <BankAccountTransactionDto>appGrid.rowSelectedData();
    var ids: number[] = [];

    if (status == BankSettlementStatusEnum.Settled) {
      appGrid.setupService.grid.getCurrentViewRecords().forEach(t => ids.unshift((t as BankAccountTransactionDto).id));
    }
    else if (status == BankSettlementStatusEnum.Selected) {
      var mainIds: number[] = this.grid.selection.rowsSelectedId();
      var detailIds: number[] = this.detailGrid.selection.rowsSelectedId();
      ids = [...mainIds, ...detailIds];
    }
    else {
      ids = appGrid.selection.rowsSelectedId();
    }
    if (ids !== null && ids.length > 0) {
      var cmd = {
        transIdList: ids,
        status: status,
      } as BankTransactionStatusSetCommand;
      if (status == BankSettlementStatusEnum.Requested) {
        this.setStatusDialog(cmd, appGrid, status, transactionFirst);
      }
      else if (status == BankSettlementStatusEnum.PendingApproval) {
        this.setStatusPendingApprovalDialog(cmd, appGrid, status, transactionFirst);
      }
      else {
        this.setStatusApi(cmd, appGrid, status);
      }
    }
  }

  private setStatusApi(cmd: BankTransactionStatusSetCommand, appGrid: CerGridComponent, status: BankSettlementStatusEnum) {
    this.ui.operationBegin();
    this.transactionClient.setTransactionStatus(cmd).subscribe(
      {
        next: (result: BankAccountTransactionDto[]) => {
          appGrid.research();
          if (appGrid == this.selectedGrid) {
            if (status != BankSettlementStatusEnum.Settled) {
              this.grid.research();
              this.detailGrid.research();
            }
          }
          else {
            this.selectedGrid.research();
          }
          this.ui.operationEnd();
        },
        error: (error) => {
          this.ui.operationEndError(error);
        }
      });
  }

  private setStatusMarkedSuggest(event: UiCommandEvent) {
    var cmd = { bankAccountId: 1 } as BankTransactionSuggestSettlementCommand;
    this.setStatusMarkedSuggestCmdApi(cmd);
  }

  private setStatusMarkedSuggestCmdApi(cmd: BankTransactionSuggestSettlementCommand) {
    this.ui.operationBegin();
    this.settlementClient.suggestSettlement(cmd).subscribe({
      next: (ok) => {
        if (ok) {
          this.selectedGrid.research();
          this.grid.research();
          this.detailGrid.research();
        }
        this.ui.operationEnd();
      },
      error: (error) => {
        this.ui.operationEndError(error);
      }
    }
    );
  }

  public setStatusPendingApprovalDialog(cmd: BankTransactionStatusSetCommand, appGrid: CerGridComponent, status: BankSettlementStatusEnum, transaction: BankAccountTransactionDto) {
    var transId = cmd.transIdList[0];
    var inputs: PromptInput[] = [
      { label: 'Godkender', id: "userId", placeholder: 'Angiv godkender', valueNumber: transaction?.user, type: 'DropDownList', dataSource: this.stateService.getDataTableCache('User').data, fields: { text: 'shortName', value: 'id' }, element: null }
    ];
    this.ui.promptInputs('', 'Angiv godkender', inputs).then(
      result => {
        if (result.action == 'ok') {
          var responsible = result.inputs[0].ej2.value;
          if (responsible != 0) {
            cmd.voucherRequestResponsible = responsible;
            this.setStatusApi(cmd, appGrid, status);
          }
          else {
            this.ui.info('Ingen godkender valgt', 'Annulleret');
          }
        }
      }
    );
  }

  public setStatusDialog(cmd: BankTransactionStatusSetCommand, appGrid: CerGridComponent, status: BankSettlementStatusEnum, transaction: BankAccountTransactionDto) {
    var trans = cmd.transIdList[0];
    var transTxt = transaction.txt.substring(0, 40);
    var inputs: PromptInput[] = [
      { label: 'Beskrivelse', id: "desc", placeholder: 'Angiv beskrivelse', value: transTxt, element: null, maxLen: 40 },
      { label: 'Modtager', id: "userId", placeholder: 'Angiv modtagende medarbejder', valueNumber: transaction.user, type: 'DropDownList', dataSource: this.stateService.getDataTableCache('User').data, fields: { text: 'shortName', value: 'id' }, element: null }
    ];
    this.ui.promptInputs('', 'Angiv modtager', inputs).then(
      result => {
        if (result.action == 'ok') {
          var desc = result.inputs[0].value;
          var responsible = result.inputs[1].ej2.value;
          if (responsible != 0) {
            cmd.voucherRequestResponsible = responsible;
            cmd.voucherRequestDescription = desc;
            this.setStatusApi(cmd, appGrid, status);
          }
          else {
            this.ui.info('Ingen tekst/modtager valgt', 'Annulleret');
          }
        }
      }
    );
  }

  private voucherCombine(event: UiCommandEvent) {
    var msgId: number = this.getEventMsgId(event);
    var userId: number = this.selectedGrid.filterService.getFieldFilterValueNumber('modifiedBy');
    var cmd = { msgId: msgId, userId: userId } as BankTransactionVoucherCombineSelectedCommand;
    this.voucherCombineCommand(cmd);
  }

  private voucherCombineCommand(cmd: BankTransactionVoucherCombineSelectedCommand) {
    this.routeService.setIsLoading(true);
    this.settlementClient.voucherCombineSelected(cmd).subscribe({
      next: (ok) => {
        if (ok) {
          this.selectedGrid.research();
          if (cmd.msgId) {
            this.voucherOpenFormMsgId(cmd.msgId)
          }
          else {
            this.selectedGrid.research();
          }
        }
        this.routeService.setIsLoading(false);
      },
      error: (error) => {
        this.routeService.setIsLoading(false);
        this.ui.errorApi(error);
      }
    });
  }

  private getEventAppGrid(event: UiCommandEvent) {
    var appGrid: CerGridComponent = null;
    if (event.appComponent && (event.appComponent instanceof CerGridComponent)) {
      appGrid = (<CerGridComponent>event.appComponent);
    };
    return appGrid;
  }

  private getEventMsgId(event: UiCommandEvent) {
    var msgId: number = null;
    if (!msgId) {
      var row = event.args.rowInfo?.rowData;
      if (!row) {
        var appGrid: CerGridComponent = this.getEventAppGrid(event);
        row = appGrid?.rowSelectedData();
      }
      if (!row?.sourceId) {
        var rows: any[] = this.selectedGrid.grid.getCurrentViewRecords();
        if (rows?.length > 0) {
          row = rows.find(t => t.sourceId != null);
        }
      }
      msgId = row?.sourceId;
    }
    return msgId;
  }

  private getEventBankTransactionId(event: UiCommandEvent) {
    var row = event.args.rowInfo?.rowData;
    if (!row || row.sourceId) {
      var appGrid: CerGridComponent = this.getEventAppGrid(event);
      row = appGrid?.rowSelectedData();
    }
    if (!row || row.sourceId) {
      var rows: any[] = this.selectedGrid.grid.getCurrentViewRecords();
      if (rows?.length > 0) {
        row = rows.find(t => t.sourceId == null);
      }
    }

    var bankTransactionId: number = null;
    if (row && !row.sourceId) {
      bankTransactionId = row.id;
    }
    return bankTransactionId;
  }


  private voucherOpenForm(event: UiCommandEvent, msgIdFixed: number = null) {
    var msgId: number = this.getEventMsgId(event);
    if (msgId) {
      this.voucherOpenFormMsgId(msgId);
    }
  }

  private voucherOpenFormMsgId(msgId: number) {
    if (msgId) {
      this.ui.operationBegin();
      this.detailsClient.get(msgId).subscribe({
        next: (vm) => {
          this.openDetailsForm(vm);
          this.ui.operationEnd();
        },
        error: (error) => {
          this.ui.operationEndError(error);
        }
      });
    }
  }

  private openDetailsForm(vm: VoucherMessageViewDetailsVm) {
    this.openVoucherDetails(this.dialog, vm, this.chatService);
  }

  public openVoucherDetails(dialog: MatDialog, vm: VoucherMessageViewDetailsVm, chatService: CerAppChatService) {
    this.voucherService.prepareDetailsVm(vm);
    if (vm.voucherMessageViewDto) {
      //this.subbase.manage(
      chatService.chats$.subscribe(chatsPosted => VoucherDataService.detailsVmRefreshChats(vm, this.chatService, chatsPosted));

      //));
      // this.voucherService.VoucherMessageAdjustDatesAsUTC(vm.voucherMessageViewDto);
      var config = <MatDialogConfig>{
        width: '98vw', height: '98vh', maxWidth: '98vw', disableClose: true,
        data: {
          dto: vm.voucherMessageViewDto,
          userIsAdmin: true,
          editVoucher: true,
          editPosting: true,
          jumpToPostingOnVoucherComplete: false,
          attachmentsIsActive: true,
          attachmentSelectedIdxDefault: 0,
          detailsVmMap: null,
          showChat: true
        }
      };
      let dialogRef: MatDialogRef<VoucherDetailComponent> = dialog.open(VoucherDetailComponent, config);
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.needRefresh) {
          this.grid.research();
          this.selectedGrid.research();
        }
      });
    }

  }

  private voucherCreate(event: UiCommandEvent) {
    var cmd = { bankTransactionId: null, status: BankSettlementStatusEnum.Selected } as BankAccountTransactionVoucherCreateCommand;
    this.voucherCreateCmd(cmd, true);
  }

  private voucherCreateFromBank(event: UiCommandEvent) {
    var bankTransactionId = this.getEventBankTransactionId(event);
    if (bankTransactionId != null) {
      var cmd = { bankTransactionId: bankTransactionId, status: BankSettlementStatusEnum.Selected } as BankAccountTransactionVoucherCreateCommand;
      this.voucherCreateCmd(cmd, true);
    }
  }

  private voucherCreateCmd(cmd: BankAccountTransactionVoucherCreateCommand, refreshAllGrids: boolean) {
    this.routeService.setIsLoading(true);
    this.transactionClient.voucherCreate(cmd).subscribe({
      next: (result) => {
        this.selectedGrid.research();
        if (refreshAllGrids) {
          this.grid.research();
          this.detailGrid.research();
        }
        this.routeService.setIsLoading(false);
      },
      error: (error) => {
        this.routeService.setIsLoading(false);
        this.ui.errorApi(error);
      }
    });
  }

  private syncBatchAll() {
    // Ikke aktiveret
    var cmd = { syncGenericSources: true } as BankAccountSourceSyncCommand;
    this.syncBatch(cmd);
  }

  private syncBatch(cmd: BankAccountSourceSyncCommand) {
    var snackBarRef = this.snackBar.open('Synkroniserer kilder', 'Vent venligst...', { duration: undefined });
    this.routeService.setIsLoading(true);
    this.batchClient.syncBatch(cmd).subscribe({
      next: (result) => {
        snackBarRef.dismiss();
        this.snackBar.open(result + ' bevægelser hentet');
        this.grid.research();
        this.routeService.setIsLoading(false);
      },
      error: (error) => {
        snackBarRef.dismiss();
        this.routeService.setIsLoading(false);
        this.ui.errorApi(error);
      }
    });
  }

  private apiVoucherMessageStatusSet(msgId: number, toStatus: VoucherMessageStatusEnum) {
    if (msgId != null && toStatus != null) {
      this.ui.operationBegin('Sæt status');
      this.routeService.setIsLoading(true);
      this.voucherMessageViewClient.setStatus(msgId, toStatus, false).subscribe({
        next: (messageDtoUpdated) => {
          this.ui.operationEnd();
          this.grid.research();
        },
        error: (error) => {
          this.ui.operationEndError(error);
        }
      });

    }
  }
}
